export const outdoor_registry = [
    { meter_id: 1278, meter_name: "Mumbai" },
    { meter_id: 1279, meter_name: "Pune" },
    { meter_id: 1280, meter_name: "Nagpur" },
    { meter_id: 1281, meter_name: "Nashik" },
    { meter_id: 1282, meter_name: "Thane" },
    { meter_id: 1283, meter_name: "Aurangabad" },
    { meter_id: 1284, meter_name: "Solapur" },
    { meter_id: 1285, meter_name: "Amravati" },
    { meter_id: 1286, meter_name: "Kolhapur" },
    { meter_id: 1287, meter_name: "Sangli" },
];